import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { Order } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-packing-slip-dialog',
    templateUrl: './packing-slip-dialog.component.html',
    styleUrls: ['./packing-slip-dialog.component.scss'],
    standalone: false
})
export class PackingSlipDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    mode: string;
    disableSlipNumber: boolean = false;
    freight: number;
    tax: number;
    notes: any;
    dealer: any;
    selectedRows: any;

    deliveryMethods: any;
    packingSlip: any;
    validationGroup = 'mainValidationGroup';
    errorAction = 'submitting';

    order: Order;
    mileageRate: number;
    calculatedFreight: number = 0;
    showFreight = false;

    onExporting = SharedModule.onExporting;

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
        private auth: AuthService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.deliveryMethods = this.uow.lookups.deliveryOptions;
        this.mileageRate = ((await this.uow.getSettingsByName('MileageRate')) as any).decimalValue;
        if (!!this.selectedRows) this.order = this.selectedRows[0].orderLine.order;
        if (!this.packingSlip) {
            this.packingSlip = this.uow.packingSlips.createEntity();
            this.packingSlip.reportGuid = crypto.randomUUID();
            this.packingSlip.packingSlipNumber = await this.utility.getNextPackingSlipNumber();
            this.packingSlip.createDate = new Date();
            this.packingSlip.createdById = this.auth.currentUser.id;
            this.packingSlip.freight = !!this.freight ? this.freight : 0;
            this.packingSlip.tax = this.tax ?? 0;
            this.packingSlip.note = this.notes;
            this.packingSlip.dealer = this.dealer;
        }
        if (this.order) await this.calcLoadedMiles();
    }

    async calcLoadedMiles() {
        if (!!this.order.dealer && !!this.order.shipAddressId) {
            const loadedMiles = ((await this.uow.shipAddresses.byId(this.order.shipAddressId)) as any).loadedMiles;
            this.calculatedFreight = loadedMiles * this.mileageRate;
        } else if (!!this.order.dealer && this.order.dealer.loadedMiles) {
            this.calculatedFreight = this.order.dealer.loadedMiles * this.mileageRate;
        } else this.calculatedFreight = 0;

        const deliveryId = this.order.deliveryOptionId;
        if (!deliveryId) {
        } else if (deliveryId === Order.DeliveryOptions.CPU || deliveryId === Order.DeliveryOptions.DPU) {
            this.showFreight = false;
        } else if (deliveryId === Order.DeliveryOptions.UPS) {
            this.showFreight = true;
        } else if (deliveryId === Order.DeliveryOptions.Genesis || deliveryId === Order.DeliveryOptions.TBD) {
            this.showFreight = false;
        }
    }

    async getData() {}

    deliverySelectionChanged = (e) => {
        if (this.packingSlip.deliveryMethod === 'PickUp') this.packingSlip.freight = 0;
        // tslint:disable-next-line:semicolon
    };

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return;

        if (this.packingSlip.freight > 0) {
            const confirmed = await confirm('Freight is greater than $0.00. Do you want to proceed?', this.appInfo.settings.company);
            if (!confirmed) return;
        }

        await this.uow.commit();
        this.result.next({ success: true, packingSlip: this.packingSlip });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
